<template lang='pug' src='./hero.pug'></template>

<script>
// import VueScrollTo from 'vue-scrollto'
import Icon from 'components/icon/icon'
import { moveTo } from '@/mixins'

export default {
  props: ['props'],
  components: {
    Icon
  },
  mixins: [ moveTo ],
  methods: {
    onScroll ({going, direction}) {
      if (going === 'out') {
        this.$store.dispatch('SCROLL', true)
        // VueScrollTo.scrollTo('#welcome', 350)
      }
      if (going === 'in') {
        this.$store.dispatch('SCROLL', false)
      }
    }
    // ,
    // handleScroll: (e, el) => {
    //   // e.preventDefault()
    //   if (window.scrollY > 10) {
    //     VueScrollTo.scrollTo('#welcome', 350)
    //   }
    //   // if (window.scrollY > 500) {
    //   //   VueScrollTo.scrollTo('#head', 350)
    //   // }
    //   console.log('scrolling: ', window.scrollY)
    // }
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?79745066